import {calcDailyBudget} from 'core/DailyBudget';

export function afterIncome(state: CoreState, input: MoneyAmount): MoneyAmount {
  const newBudget = {...state.budget, added: state.budget.added + input};
  const newDaily = calcDailyBudget(newBudget, state.history);
  return newDaily.amount;
}
